module.exports = __webpack_public_path__ + "img/services-details-3.b92f7690.jpg";